import OneSignal from 'react-onesignal';

const ONESIGNAL_APP_ID = process.env.REACT_APP_ONESIGNAL_APP_ID;

let initialized = false;

/**
 * Initialize OneSignal for web push notifications
 */
export const initOneSignal = async () => {
  if (initialized || !ONESIGNAL_APP_ID) {
    if (!ONESIGNAL_APP_ID) {
      console.warn('OneSignal: REACT_APP_ONESIGNAL_APP_ID not set. Push notifications disabled.');
    }
    return;
  }

  try {
    // Skip initialization on non-production domains
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname.includes('preview.')) {
      console.log('OneSignal: Skipping init on non-production domain');
      return;
    }

    await OneSignal.init({
      appId: ONESIGNAL_APP_ID,
      allowLocalhostAsSecureOrigin: true,
      notifyButton: {
        enable: true,
        position: 'bottom-right',
        size: 'medium',
        text: {
          'tip.state.unsubscribed': 'Get attendance notifications',
          'tip.state.subscribed': 'Notifications enabled',
          'dialog.main.title': 'Manage Notifications',
          'dialog.main.button.subscribe': 'Enable',
          'dialog.main.button.unsubscribe': 'Disable',
        },
      },
      welcomeNotification: {
        title: 'AMS Notifications Enabled',
        message: "You'll receive alerts for leaves, attendance, and anomalies.",
      },
    });

    initialized = true;
    console.log('OneSignal: Initialized successfully');

    // Set up notification click handler
    OneSignal.Notifications.addEventListener('click', (event) => {
      const data = event.notification?.data;
      if (data?.event_type) {
        handleNotificationClick(data);
      }
    });
  } catch (error) {
    console.error('OneSignal: Init failed -', error);
  }
};

/**
 * Login user to OneSignal (set external user ID)
 */
export const loginOneSignal = (externalId) => {
  if (!initialized || !externalId) return;
  try {
    OneSignal.login(String(externalId));
    console.log('OneSignal: User logged in as', externalId);
  } catch (error) {
    console.error('OneSignal: Login failed -', error);
  }
};

/**
 * Logout user from OneSignal
 */
export const logoutOneSignal = () => {
  if (!initialized) return;
  try {
    OneSignal.logout();
    console.log('OneSignal: User logged out');
  } catch (error) {
    console.error('OneSignal: Logout failed -', error);
  }
};

/**
 * Add tags for notification targeting
 */
export const setOneSignalTags = (tags) => {
  if (!initialized) return;
  try {
    OneSignal.User.addTags(tags);
  } catch (error) {
    console.error('OneSignal: Tag set failed -', error);
  }
};

/**
 * Request notification permission
 */
export const requestPermission = async () => {
  if (!initialized) return false;
  try {
    await OneSignal.Notifications.requestPermission();
    return true;
  } catch (error) {
    console.error('OneSignal: Permission request failed -', error);
    return false;
  }
};

/**
 * Handle notification click navigation
 */
const handleNotificationClick = (data) => {
  switch (data.event_type) {
    case 'leave_approved':
    case 'leave_rejected':
    case 'leave_request':
      window.location.href = '/leaves';
      break;
    case 'punch_reminder':
      window.location.href = '/attendance';
      break;
    case 'anomaly_alert':
      window.location.href = '/dashboard';
      break;
    case 'sync_complete':
      window.location.href = '/attendance';
      break;
    default:
      window.location.href = '/dashboard';
  }
};
